import React, {useState} from "react"
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CCOLink from "./CCOLink";
import {generateDownloadUrl} from "../../utility/navigationUtil";
import {ctaFocusRing} from "../../common/constants/focusStyle";
import {useTheme} from "@mui/material/styles";
import {useTeaserCardSelect} from "tracking/hooks/useTeaserCardSelect";


interface Props {
    background?: string
    border?: boolean
    children?: JSX.Element | JSX.Element[]
    customStyle?: any
    hasFocusedStyle?: boolean
    isTargetCMDownload?: boolean
    item: any
    noLink?: boolean
    noSize?: boolean
    padding?: number
    paddingY?: number
    paddingX?: number
    dataCypress?: string
    customLink?: string
    teasercardLocation?: string
}

function CCOCard(props: Props) {
    const theme = useTheme();
    const [isCardFocused, setIsCardFocused] = useState(false);

    const downloadTarget = props.isTargetCMDownload
                           || props.item.teaserTarget && props.item.teaserTarget.type ===
                           "CMDownload" ?
        generateDownloadUrl(
            props.item.teaserTarget.id ?? '',
            props.item.teaserTarget.teaserTitle ?? '')
        : undefined

    const handleOnFocus = () => {
        props.noLink ? setIsCardFocused(false) : setIsCardFocused(true);
    };

    const openLinkInNewTab = props.item.teaserTarget?.openInNewTab || downloadTarget !== undefined;

    const handleOnFocusOut = () => {
        setIsCardFocused(false);
    };

    const CCOCardStyle = {
        paddingY: props.paddingY ?? props.padding ?? 2,
        paddingX: props.paddingX ?? props.padding ?? 2,
        border: props.border ? '4px solid #ffffff' : '',
        width: props.noSize ? 'inherit' : '100%',
        height: props.noSize ? undefined : '100%',
        background: props.hasFocusedStyle && isCardFocused ? theme.palette.primary.light :
            props.background ? props.background : undefined,
        boxShadow: 'none',
        display: 'flex',
        "h6": {
            transition: "color 1s ease-out",
        },
        "img": {
            transition: "all 3s ease"
        },
        ":hover h6": props.noLink ? {} : {
            color: 'primary.main',
        },
        ":hover img": {},
        "a": {
            height: "100%!important",
            width: '100%!important'
        },
        '& > a > div > div.MuiBox-root': {
            backgroundColor: props.hasFocusedStyle && isCardFocused ? theme.palette.primary.light :
                undefined,
        },
        '& .show-more-with-focus': props.hasFocusedStyle && isCardFocused && !props.noLink ? {
            outline: '2px solid #ccc',
            borderRadius: '5px',
            outlineColor: theme.palette.primary.main,
            textDecoration: 'none!important'
        } : {},
        '& a:focus-visible .cta-button-div': ctaFocusRing(),
        ...props.customStyle,
    }

    const handleTeaserSelect = useTeaserCardSelect({
                                                       item: props.item,
                                                       dataCypress: props.dataCypress,
                                                       teasercardLocation: props.teasercardLocation
                                                   });

    return (
        <Card data-cypress={props.dataCypress} sx={CCOCardStyle} onClick={handleOnFocusOut}
                     onFocus={handleOnFocus}
                     onBlur={handleOnFocusOut}>
            {props.noLink ?
                <Box sx={{
                    width: '100%'
                }}>
                    {props.children}
                </Box> :
                <CCOLink target={props.customLink ?? downloadTarget ?? props.item!}
                         openInTab={openLinkInNewTab}
                         noLinkIcon={openLinkInNewTab}
                         onClick={handleTeaserSelect}>
                    <Box sx={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
                        {props.children}
                    </Box>
                </CCOLink>}
        </Card>
    );
}

export default CCOCard